import { SpotLight } from "@react-three/drei";
import { Vector3, useThree } from "@react-three/fiber";
import { forwardRef } from "react";
import THEME from "../../../../shared/constants/app-theme.module.scss";

type Props = {
  position: Vector3;
};

const LightRay = forwardRef(({ position }: Props, ref: any) => {
  const { viewport } = useThree();

  return (
    <>
      <SpotLight
        scale={(viewport.width / 3) * 1}
        ref={ref}
        castShadow
        color={THEME.purple}
        position={position}
        distance={7}
        attenuation={9}
        angle={0.25}
        anglePower={2}
        opacity={0}
        matrixWorldNeedsUpdate={true}
      />

{/* <SpotLight
        scale={(viewport.width / 3) * 1}
        // scale={1.05}
        ref={ref}
        castShadow
        color={THEME.purple}
        position={[-0.1, 2.3, 0]}
        distance={1.92}
        attenuation={9}
        angle={0.08}
        anglePower={2}
        opacity={0}
        matrixWorldNeedsUpdate={true}
      /> */}
    </>
  );
});

export default LightRay;
